<mat-form-field>
  <mat-label>Straße</mat-label>
  <input
    matInput
    [formControl]="streetControl()"
    [matAutocomplete]="streetAutocomplete"
    autocomplete="nope"
  />
  <mat-error ui-input-errors [control]="streetControl()" />
</mat-form-field>

<mat-autocomplete #streetAutocomplete="matAutocomplete">
  @if (streetResult$ | async; as streetResult) {
    @if (isLoading()) {
      <mat-option>
        <div class="flex justify-between items-center gap-4">
          <mat-spinner color="primary" [diameter]="20" />
          <div>lädt...</div>
        </div>
      </mat-option>
    } @else {
      @if (!streetResult.length) {
        <!-- disabled: a selectable option here would write null over what was typed -->
        <mat-option disabled>keine Auswahl</mat-option>
      }
      @for (item of streetResult; track item) {
        <mat-option (onSelectionChange)="onStreetSelect(item, $event)" [value]="item.name">
          {{ item.name }}
        </mat-option>
      }
    }
  }
</mat-autocomplete>
